/* Iter122du · Pagina pubblica /piani — Ginius listino + istruzioni attivazione.
   Iter122fa · Se l'utente è autenticato mostra 2 CTA di navigazione app:
   ← Torna alla App (Dashboard) · Vai alla sezione Le mie licenze → */
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Check, X as XIcon, Download, ArrowLeft, ArrowRight, Landmark, CreditCard, Sparkles, Lock, Home, Building2 } from "lucide-react";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Iter122eb · label sezioni per messaggio upgrade (allineato con backend plan_utils.SECTION_LABELS)
const SECTION_LABELS = {
  raccolta_dati: "Raccolta dati", preventivi: "Preventivi", credius: "Credius",
  credius_anagrafica: "Credius Anagrafiche", sinistri: "Sinistri assicurativi",
  privacy: "Privacy", ras: "RAS", appalti: "Gestione appalti",
  statistiche: "Statistiche", report: "Report",
  impostazioni_account: "Impostazioni & Account",
  importa_dati: "Importa dati",
  dashboard: "Dashboard", nuova_manutenzione: "Nuova manutenzione",
  manutenzioni: "Manutenzioni", stabili: "Stabili", anagrafica: "Anagrafica condòmini",
  account_condomini: "Account condòmini", bacheca: "Bacheca · Moduli",
  account_fornitori: "Account fornitori", comunicazioni_fornitori: "Comunicazione fornitori",
  calendario: "Calendario", guida: "Guide e manuali", video: "Video dimostrativi",
};

const PIANO_COLORS = {
  trial: { bg: "bg-emerald-600", ring: "ring-emerald-500", accent: "text-emerald-600" },
  light: { bg: "bg-slate-700", ring: "ring-slate-500", accent: "text-slate-700" },
  full: { bg: "bg-brand", ring: "ring-brand", accent: "text-brand" },
  pro: { bg: "bg-amber-500", ring: "ring-amber-500", accent: "text-amber-600" },
};

export default function Piani() {
  const { user } = useAuth();
  const isAuthed = !!user && user !== false;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [params] = useSearchParams();
  const upgradeFrom = params.get("upgrade");
  useEffect(() => {
    axios.get(`${API}/piani/info`).then((r) => { setData(r.data); setLoading(false); });
  }, []);

  if (loading || !data) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento listino…</div>;

  const { piani, matrice, bonifico } = data;

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-slate-50 to-white">
      {/* Header */}
      <div className="border-b bg-white/80 backdrop-blur sticky top-0 z-10" data-testid="piani-header">
        <div className="max-w-6xl mx-auto px-4 py-3 flex flex-wrap items-center gap-2 justify-between">
          {isAuthed ? (
            <>
              <Link to="/" data-testid="piani-back-dashboard-btn"
                className="inline-flex items-center gap-2 rounded-full bg-slate-100 text-slate-800 font-bold text-sm px-4 py-1.5 hover:bg-slate-200 transition-colors">
                <ArrowLeft className="w-4 h-4" /> <Home className="w-4 h-4" /> Torna alla App
              </Link>
              <div className="flex items-center gap-2">
                <a href={`${API}/piani/pdf`} target="_blank" rel="noreferrer"
                   data-testid="piani-pdf-download"
                   className="inline-flex items-center gap-2 rounded-full bg-white border-2 border-brand text-brand text-sm font-bold px-4 py-1.5 hover:bg-brand/5">
                  <Download className="w-4 h-4" /> Scarica PDF
                </a>
                <Link to="/pannello?tab=licenze-condomini" data-testid="piani-forward-licenze-btn"
                  className="inline-flex items-center gap-2 rounded-full bg-brand text-white font-bold text-sm px-4 py-1.5 hover:bg-brand-dark transition-colors">
                  <Building2 className="w-4 h-4" /> Le mie licenze <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </>
          ) : (
            <>
              <Link to="/login" className="inline-flex items-center gap-2 text-brand font-bold hover:underline">
                <ArrowLeft className="w-4 h-4" /> Torna al login
              </Link>
              <a href={`${API}/piani/pdf`} target="_blank" rel="noreferrer"
                 data-testid="piani-pdf-download"
                 className="inline-flex items-center gap-2 rounded-full bg-brand text-white text-sm font-bold px-4 py-1.5 hover:bg-brand-dark">
                <Download className="w-4 h-4" /> Scarica PDF listino
              </a>
            </>
          )}
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-10">
        {upgradeFrom && (
          <Card data-testid="upgrade-banner" className="mb-6 p-4 sm:p-5 border-2 border-amber-300 bg-amber-50 flex items-start gap-3">
            <Lock className="w-6 h-6 text-amber-700 shrink-0 mt-0.5" />
            <div>
              <div className="font-bold text-amber-900 text-base">Sezione bloccata: {SECTION_LABELS[upgradeFrom] || upgradeFrom}</div>
              <p className="text-sm text-amber-800 mt-1">
                Questa funzione non è inclusa nel piano attuale del tuo condominio.
                Consulta la matrice qui sotto e attiva il piano che include la sezione desiderata da
                <Link to="/pannello" className="underline font-bold ml-1">Impostazioni & Account → Le mie licenze condòmini</Link>.
              </p>
            </div>
          </Card>
        )}
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-brand mb-2">Ginius · Piani e Funzioni<span className="text-amber-500">.</span></h1>
        <p className="text-slate-500 text-base max-w-3xl">Scegli il piano più adatto al tuo condominio. Tutti i prezzi sono <b>per condominio/anno</b> e comprensivi di <b>IVA 22%</b>.</p>

        {/* Cards piani */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8" data-testid="piani-cards">
          {piani.map((p) => {
            const c = PIANO_COLORS[p.key];
            return (
              <Card key={p.key} className={`p-5 border-2 hover:ring-4 ${c.ring} ring-opacity-20 transition`}
                data-testid={`piano-card-${p.key}`}>
                <div className={`${c.bg} text-white px-3 py-1 rounded-full inline-block text-xs font-bold uppercase tracking-wide`}>{p.nome}</div>
                <div className="mt-3 text-3xl font-bold text-slate-900">{p.prezzo}</div>
                <p className="text-xs text-slate-500 mt-1 leading-snug">{p.sub}</p>
                <ul className="mt-4 space-y-1 text-sm">
                  {matrice.filter((m) => m[p.key]).slice(0, 8).map((m) => (
                    <li key={m.sezione} className="flex items-center gap-1.5 text-slate-700">
                      <Check className="w-3.5 h-3.5 text-emerald-600 shrink-0" /> {m.sezione}
                    </li>
                  ))}
                  {matrice.filter((m) => m[p.key]).length > 8 && (
                    <li className="text-xs text-slate-500 italic">+ altre {matrice.filter((m) => m[p.key]).length - 8} sezioni</li>
                  )}
                </ul>
              </Card>
            );
          })}
        </div>

        {/* Matrice comparativa */}
        <h2 className="font-display text-2xl font-bold text-brand mt-12 mb-4">Confronto sezioni</h2>
        <Card className="overflow-hidden border-2" data-testid="piani-matrix">
          <table className="w-full text-sm">
            <thead className="bg-brand text-white">
              <tr>
                <th className="text-left px-3 py-2 font-bold">Sezione</th>
                {piani.map((p) => {
                  const c = PIANO_COLORS[p.key];
                  return <th key={p.key} className={`px-3 py-2 text-center font-bold ${c.bg}`}>{p.nome}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {matrice.map((m, i) => (
                <tr key={m.sezione} className={i % 2 ? "bg-slate-50" : "bg-white"}>
                  <td className="px-3 py-1.5 text-slate-700">{m.sezione}</td>
                  {piani.map((p) => (
                    <td key={p.key} className="px-3 py-1.5 text-center">
                      {m[p.key] ? <Check className="w-4 h-4 text-emerald-600 inline" /> : <XIcon className="w-4 h-4 text-slate-300 inline" />}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </Card>

        {/* Step-by-step */}
        <h2 className="font-display text-2xl font-bold text-brand mt-12 mb-4">Come attivare le licenze — passo dopo passo</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="piani-steps">
          {[
            { n: 1, t: "Vai in Impostazioni & Account", d: "Dopo il login, apri la sezione dalla sidebar. Qui trovi tutti i tuoi condomìni e la gestione delle licenze." },
            { n: 2, t: "Scegli il piano", d: "Per ogni condominio da attivare seleziona il piano desiderato (Light/Full/Pro+) dal menu a tendina." },
            { n: 3, t: "Clicca \"Attiva Condominio\"", d: "Lo stato passa da \"Da attivare\" (rosso) a \"Attivazione richiesta\" (giallo). Si apre la pagina di pagamento." },
            { n: 4, t: "Paga con Bonifico o Stripe", d: "Bonifico con causale dedicata (attivazione ~48h) oppure carta via Stripe (pagamento immediato)." },
            { n: 5, t: "Attesa conferma dello Studio", d: "Il team Ginius verifica il pagamento. Ricevi notifica appena passa a \"Licenza attiva\" (verde)." },
            { n: 6, t: "Fatturazione fiscale", d: "Fattura elettronica intestata al condominio secondo i dati inseriti in Stabili." },
          ].map((s) => (
            <Card key={s.n} className="p-4 border-2 hover:border-brand transition" data-testid={`piani-step-${s.n}`}>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-full bg-brand text-white flex items-center justify-center font-bold shrink-0">{s.n}</div>
                <div>
                  <div className="font-bold text-brand mb-1">{s.t}</div>
                  <p className="text-sm text-slate-600 leading-snug">{s.d}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Box pagamento */}
        <h2 className="font-display text-2xl font-bold text-brand mt-12 mb-4">Modalità di pagamento</h2>
        <div className="grid sm:grid-cols-2 gap-4" data-testid="piani-pagamento">
          <Card className="p-5 border-2 border-amber-200 bg-amber-50/40">
            <div className="flex items-center gap-2 mb-2">
              <Landmark className="w-5 h-5 text-amber-700" />
              <h3 className="font-bold text-lg text-amber-900">Bonifico Bancario</h3>
            </div>
            <dl className="text-sm space-y-1 text-slate-700">
              <div><dt className="inline font-semibold">Intestatario: </dt><dd className="inline">{bonifico.intestatario || "—"}</dd></div>
              <div><dt className="inline font-semibold">IBAN: </dt><dd className="inline font-mono text-xs">{bonifico.iban || "—"}</dd></div>
              {bonifico.banca && <div><dt className="inline font-semibold">Banca: </dt><dd className="inline">{bonifico.banca}</dd></div>}
              {bonifico.bic_swift && <div><dt className="inline font-semibold">BIC/SWIFT: </dt><dd className="inline font-mono text-xs">{bonifico.bic_swift}</dd></div>}
              <div className="pt-2"><dt className="inline font-semibold">Causale: </dt><dd className="inline italic">{bonifico.causale_template}</dd></div>
            </dl>
            <p className="text-xs text-amber-800 mt-3 leading-snug">{bonifico.note}</p>
            {bonifico.email_contabile && <p className="text-xs text-amber-800 mt-2">Contabile: <a href={`mailto:${bonifico.email_contabile}`} className="underline font-semibold">{bonifico.email_contabile}</a></p>}
          </Card>
          <Card className="p-5 border-2 border-sky-200 bg-sky-50/40">
            <div className="flex items-center gap-2 mb-2">
              <CreditCard className="w-5 h-5 text-sky-700" />
              <h3 className="font-bold text-lg text-sky-900">Pagamento elettronico (Stripe)</h3>
            </div>
            <p className="text-sm text-slate-700 leading-snug">
              Carta di credito o debito &middot; pagamento immediato via Stripe. L&apos;attivazione della licenza è
              istantanea al completamento del pagamento.
            </p>
            <div className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-sky-700 bg-sky-100 px-2 py-1 rounded-full">
              <Sparkles className="w-3.5 h-3.5" /> Attivazione immediata dopo il pagamento
            </div>
          </Card>
        </div>

        <div className="mt-14 pt-6 border-t text-xs text-slate-500 text-center">
          Ginius by Amministrazioni Izzo · <a href="mailto:info@amministrazionizzo.com" className="underline">info@amministrazionizzo.com</a> · listino aggiornato periodicamente.
        </div>
      </div>
    </div>
  );
}
